import _ from 'lodash';
import { appendRepeatableInstancesToId } from '../RepeatableExpansion';
// TODO @MultiInsured This goes elsewhere -- but where?
export function isRenderingQuestionnaireComplete(questionnaire) {
    return _.every(questionnaire, ['completed', true]);
}
// TODO @MultiInsured -- Move these to a questionnaireQueries module
function getAllFieldGroups(questionnaire) {
    const sections = _.flatMap(questionnaire, 'sections');
    const subsections = _.flatMap(sections, 'subsections');
    return _.flatMap(subsections, 'fieldGroups');
}
function getAllFields(questionnaire) {
    const fieldGroups = getAllFieldGroups(questionnaire);
    return _.flatMap(fieldGroups, 'fields');
}
export function getSectionGroupById(sectionGroups, id) {
    return _.find(sectionGroups, (sectionGroup) => sectionGroup.id === id);
}
export function getSectionById(sectionGroup, id) {
    return _.find(sectionGroup.sections, (section) => section.id === id);
}
export function findFieldInRenderingQuestionnaire(questionnaire, fieldId, repeatedIdentifiers) {
    const allFields = getAllFields(questionnaire);
    const targetId = appendRepeatableInstancesToId(fieldId, repeatedIdentifiers ?? {});
    return allFields.find((field) => field.id === targetId);
}
